import React from "react";

interface MobileSaveButtonProps {
  onClick: () => void;
}

const MobileSaveButton: React.FC<MobileSaveButtonProps> = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="px-4 py-2 bg-blue-500 hover:bg-green-600 text-white text-sm font-bold rounded shadow-lg transition-colors pointer-events-auto
                 hidden max-[768px]:block"
      style={{ pointerEvents: "all" }}
    >
      Save
    </button>
  );
};

export default MobileSaveButton;
